/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coinvestments_Emailtemplate_Insertplaceholder3Inputs */

const en_coinvestments_emailtemplate_insertplaceholder3 = /** @type {(inputs: Coinvestments_Emailtemplate_Insertplaceholder3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insert ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Insert {name}" |
*
* @param {Coinvestments_Emailtemplate_Insertplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_emailtemplate_insertplaceholder3 = /** @type {((inputs: Coinvestments_Emailtemplate_Insertplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Emailtemplate_Insertplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_emailtemplate_insertplaceholder3(inputs)
});
export { coinvestments_emailtemplate_insertplaceholder3 as "coInvestments_emailTemplate_insertPlaceholder" }